import { render } from "./category-customvariables-tab.vue?vue&type=template&id=2afea957&scoped=true"
import script from "./category-customvariables-tab.vue?vue&type=script&lang=js"
export * from "./category-customvariables-tab.vue?vue&type=script&lang=js"

import "./category-customvariables-tab.vue?vue&type=style&index=0&id=2afea957&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afea957"]])

export default __exports__